import React, { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Plot from "react-plotly.js";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Heatmap from "./Heatmap";
import Projectcolors from "../Utils/Colors";
import { ListItemAvatar, Typography } from "@mui/material";
import LinePlotRaw from "./LinePlotRaw";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";

const menuprops = {
  PaperProps: {
    style: {
      maxHeight: 250,

    },
  },
};

function Scatterplot() {
  const [rawdata, setRawData] = React.useState([]);

  const [lineplotdata, setLineplotdata] = React.useState([]);

  const [lineplotx, setLineplotx] = React.useState([]);
  const [x, setX] = React.useState("");
  const [y, setY] = React.useState("");
  const [ylabel, setYLabel] = React.useState("Y axis");
  const [xlabelscatter, setXscatter] = React.useState();
  const [ylabelscatter, setYscatter] = React.useState();
  const [alltagname, setTagname] = React.useState([]);
  const [getLoader, setGetLoader] = React.useState(false);
  const [timeseries, setTimeseries] = React.useState(0);

  const handledropdownx = (e) => {
    setX(e.target.value);
    setXscatter(rawdata[e.target.value][1]);
  };
  const handledropdowny = (e) => {
    setY(e.target.value);
    setYscatter(rawdata[e.target.value][1]);
  };

  useEffect(() => {
    getRawData();
  }, []);

  const getRawData = () => {
    setGetLoader(true);

    const ProjectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/getrawdata?projectID=${ProjectID}&scatterplot=${1}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())

      .then((raw) => {
        setRawData(raw.raw_data);
        setLineplotdata(raw.lineplotdata);
        setLineplotx(raw.lineplotdata[0]);
        setTagname(raw.tag_name);
        setX(0);
        setY(1);
        setXscatter(alltagname[0]);
        setYscatter(alltagname[1]);
        setGetLoader(false);
        setTimeseries(raw.timeseries);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("caught it!", err);
      });
  };




  const handleSelect = () =>{
    if(xlabelscatter){

      return <span style={{color:"black"}}>{xlabelscatter}</span>
    } 
    return <span style={{color:"#888888"}}>Select</span>
  }

  const handleSelectY = () =>{
    if(ylabelscatter){

      return <span style={{color:"black"}}>{ylabelscatter}</span>
    } 
    return <span style={{color:"#888888"}}>Select</span>
  }


  return (
  <Box
    sx={{
      display: "flex",
      gap: 2,
      width: "100%",
      height: "100%",
    }}
  >
    {/* Plot Card */}
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        p: 2,
        borderRadius: "22px",
        boxShadow: "0px 6px 24px rgba(0,0,0,.06)",
      }}
    >
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 600,
          color: "#0078c9",
          mb: 2,
        }}
      >
        Scatter Analysis
      </Typography>

      <Plot
        data={[
          {
            x: lineplotdata[x],
            y: lineplotdata[y],
            type: "scatter",
            mode: "markers",

            marker: {
              color: "#9e0b22",
              size: 8,
            },
          },
        ]}
        layout={{
          autosize: true,

          margin: {
            l: 70,
            r: 20,
            b: 70,
            t: 20,
          },

          xaxis: {
            title: xlabelscatter,
            automargin: true,
          },

          yaxis: {
            title: ylabelscatter,
            automargin: true,
          },

          paper_bgcolor: "white",
          plot_bgcolor: "white",
        }}
        useResizeHandler={true}
        style={{
          width: "100%",
          height: "450px",
        }}
        config={{
          responsive: true,
          displaylogo: false,
        }}
      />
    </Paper>

    {/* Controls */}
    <Paper
      elevation={0}
      sx={{
        width: 250,
        p: 2,
        borderRadius: "22px",
        height: "fit-content",
        boxShadow: "0px 6px 24px rgba(0,0,0,.06)",
      }}
    >
      <Typography
        sx={{
          fontSize: "12px",
          color: "#0078c9",
          fontWeight: 600,
          mb: 2,
        }}
      >
        Plot Controls
      </Typography>

      <Typography
        sx={{
          fontSize: "12px",
          mb: .7,
        }}
      >
        X Axis
      </Typography>

      <FormControl fullWidth sx={{mb:2}}>
        <Select
          defaultValue="AAAA"
          onChange={handledropdownx}
          MenuProps={menuprops}
          renderValue={handleSelect}
          sx={{
            fontSize: "12px",
            borderRadius: "12px",

            "& .MuiOutlinedInput-notchedOutline":{
              borderColor:"rgba(0,120,201,.2)"
            },

            "&:hover .MuiOutlinedInput-notchedOutline":{
              borderColor:"#9e0b22"
            },

            "&.Mui-focused .MuiOutlinedInput-notchedOutline":{
              borderColor:"#0078c9"
            }
          }}
        >
          {rawdata?.map((item,i)=>(
            <MenuItem
              key={i}
              value={i}
              sx={{
                fontSize:"12px"
              }}
            >
              {item[1]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography
        sx={{
          fontSize: "12px",
          mb: .7,
        }}
      >
        Y Axis
      </Typography>

      <FormControl fullWidth>
        <Select
          defaultValue="AAA"
          onChange={handledropdowny}
          MenuProps={menuprops}
          renderValue={handleSelectY}
          sx={{
            fontSize:"12px",
            borderRadius:"12px",

            "& .MuiOutlinedInput-notchedOutline":{
              borderColor:"rgba(0,120,201,.2)"
            },

            "&:hover .MuiOutlinedInput-notchedOutline":{
              borderColor:"#9e0b22"
            },

            "&.Mui-focused .MuiOutlinedInput-notchedOutline":{
              borderColor:"#0078c9"
            }
          }}
        >
          {rawdata?.map((item,i)=>(
            <MenuItem
              value={i}
              key={i}
              sx={{
                fontSize:"12px"
              }}
            >
              {item[1]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Paper>

    {getLoader && <GlobalLoader />}
  </Box>
);
}

export default Scatterplot;
